import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import { Card, CardBody } from "reactstrap";
import FeatherIcon from "feather-icons-react";
import CardWidgetSkeleton from "Components/Common/CardWidgetSkeleton";
import { getPaymentsAgencyCount } from "common/services/payments.service";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import AgencyModal from "pages/Agencies/AgencyModal";

const TotalActivePartners = () => {
  const { id: mdaId } = useParams();
  const [loading, setLoading] = useState(false);
  const [totalActivePartners, setTotalActivePartners] = useState(0);
  const [totalPartners, setTotalPartners] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = (e?: React.MouseEvent) => {
    if (e) {
      e.preventDefault();
    }
    setIsModalOpen(!isModalOpen);
  };

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const response: any = await getPaymentsAgencyCount({
          mdaId,
        });
        setTotalPartners(response?.agencyCount);
      } catch (error) {
        console.warn("Error fetching total active contracts", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [mdaId]);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const response: any = await getPaymentsAgencyCount({
          mdaId,
          active: true,
        });
        setTotalActivePartners(response?.agencyCount);
      } catch (error) {
        console.warn("Error fetching total active contract", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [mdaId]);

  const filter = {
    mda: {
      value: mdaId,
      label: "",
    },
    status: "active",
  };

  // const percentageValue = useMemo(() => {
  //   if (totalPartners === 0) return 0;
  //   return (totalActivePartners / totalPartners) * 100;
  // }, [totalActivePartners, totalPartners]);

  if (loading) {
    return <CardWidgetSkeleton />;
  }
  return (
    <Link to={`#`} onClick={toggleModal}>
      <Card className="card-animate">
        <CardBody>
          <div className="d-flex justify-content-between">
            <div>
              <p className="fw-medium text-muted mb-0">Supporting Partners</p>
              <h2 className="mt-4 ff-secondary cfs-22 fw-semibold">
                <span className="counter-value" data-target="33.48">
                  <CountUp
                    start={0}
                    end={totalPartners}
                    decimals={0}
                    duration={2}
                  />
                </span>
              </h2>
              <p className="mb-0 text-muted text-truncate">
                {/* <span className="badge bg-light text-success mb-0"> */}
                {/* <i className="ri-arrow-up-line align-middle"></i>  */}
                {/* {totalActivePartners} Active */}
                {/* </span>{" "} */}
                <span>{totalActivePartners} Active</span>
              </p>
            </div>
            <div>
              <div className="avatar-sm flex-shrink-0">
                <span className="avatar-title bg-info-subtle rounded-circle fs-2">
                  <FeatherIcon icon="globe" className="text-success" />
                </span>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
      <AgencyModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        title="Total Partners"
        filter={filter}
      />
    </Link>
  );
};

export default TotalActivePartners;
